export class OneboxTimeout {
  editable = false;
  id = '';
  value = '';
}
